<template>

  <form class="form normal entry" @submit.prevent="handleSubmit">

    <div class="left-section">

      <div>

        <Logo class="mobile" />

        <Logo :logoOverride="logo2" class="desktop" />

      </div>

    </div><div class="wrap">

      <div class="wrap-wrap">
 
        <div class="wrap-wrap-wrap">

          <h2 class="form-section-title">Maintenance</h2>

		<p>RankCaddy offline for a quick bit of maintenance, it will be back online shortly.</p>

        </div>

      </div>

    </div>

  </form>

</template>

<script>
import { mapState } from "vuex";
import Logo from './../components/Logo.vue'
import ApiService from './../services/api.service'
export default {
	name: "Maintenance",
	components: { Logo },
	data() {
	return {};
	},
	computed: {

		...mapState('general',['logo2'])

	},
	methods: {

		check () {

			ApiService.get( 'maintenance' )
			.then( function( info ) {

				if ( !info.data ) {

					window.location.assign('/login');

				}
				else {

					setTimeout( function () { this.check(); }.bind(this), 10000 );

				}

			}.bind(this))
			.catch( function(err) {
			console.log(err);
			});

		}

	},
	beforeMount() {

		this.check();

    }
};
</script>
